/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styled, { css } from 'styled-components';
import { background, border, color, layout, position, shadow, space, typography, compose } from 'styled-system';
import { ifProp, prop } from 'styled-tools';

import { createSystemPropFilter } from '@utils/styled-component-tools.ts';

interface StyledTextProps {
  $limitLinesOfTextTo?: number;
  [key: string]: any;
}

const system = compose(background, border, color, layout, position, shadow, space, typography);

const StyledText = styled('span').withConfig({ shouldForwardProp: createSystemPropFilter(system) })<StyledTextProps>`
  ${ifProp(
    '$limitLinesOfTextTo',
    css`
      -webkit-box-orient: vertical;
      /* Limit the text block to x lines */
      -webkit-line-clamp: ${prop('$limitLinesOfTextTo')};
    `,
    ``,
  )}
  line-height: 1.5;
  /* Styled System Overrides Everything always comes last */
  ${system}
`;

export interface TextProps {
  ref?: React.Ref<HTMLSpanElement>;
  'data-testid'?: string;
  limitLinesOfTextTo?: number;
  [key: string]: unknown;
}

const Text = ({ ref, 'data-testid': dataTestId = 'Text', limitLinesOfTextTo, ...props }: TextProps) => {
  return (
    <StyledText
      ref={ref}
      data-testid={dataTestId}
      fontSize="sm"
      fontFamily="default"
      $limitLinesOfTextTo={limitLinesOfTextTo}
      {...props}
    />
  );
};

Text.displayName = 'Text';

export default Text;
